import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceNearRoutingModule } from './service-near-routing.module';
import { ServiceNearDashboardComponent } from './service-near-dashboard/service-near-dashboard.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/common/ui-components/components.module';
import { ServiceDetailsComponent } from './service-details/service-details.component';
import { ServiceNearToolbarComponent } from './service-near-toolbar/service-near-toolbar.component';
import { ServiceAddComponent } from './service-add/service-add.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ServiceNearMoreMenulistComponent } from './service-near-more-menulist/service-near-more-menulist.component';
import { ServiceNearContactUsComponent } from './service-near-contact-us/service-near-contact-us.component';
import { ServiceNearPayinComponent } from './service-near-payin/service-near-payin.component';
import { ServiceListComponent } from './service-list/service-list.component';
import { ShopReportComponent } from './shop-report/shop-report.component';
import { WhatsNewComponent } from './whats-new/whats-new.component';
import { SalesListComponent } from './sales-list/sales-list.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AccountInfoComponent } from './account-info/account-info.component';
import { ServiceUniqueIdComponent } from './service-unique-id/service-unique-id.component';
import { ServicenearProfileComponent } from './servicenear-profile/servicenear-profile.component';
import { ServiceProductListComponent } from './service-product-list/service-product-list.component';
import { ServicenearSuperadminComponent } from './servicenear-superadmin/servicenear-superadmin.component';
import { ServicenearSellersDetailsComponent } from './servicenear-sellers-details/servicenear-sellers-details.component';
import { ServicenearSettingsComponent } from './servicenear-settings/servicenear-settings.component';
import { ServicenearSocialProfilesComponent } from './servicenear-social-profiles/servicenear-social-profiles.component';
import { ServicenearMyOtherDevicesComponent } from './servicenear-my-other-devices/servicenear-my-other-devices.component';
import { NgxPatternLockComponent } from 'ngx-pattern-lock';
import { DragDropModule } from '@angular/cdk/drag-drop';


@NgModule({
  declarations: [
    ServiceNearDashboardComponent,
    ServiceDetailsComponent,
    ServiceNearToolbarComponent,
    ServiceAddComponent,
    ServiceNearMoreMenulistComponent,
    ServiceNearContactUsComponent,
    ServiceNearPayinComponent,
    ServiceListComponent,
    ShopReportComponent,
    WhatsNewComponent,
    SalesListComponent,
    ChangePasswordComponent,
    AccountInfoComponent,
    ServiceUniqueIdComponent,
    ServicenearProfileComponent,
    ServiceProductListComponent,
    ServicenearSuperadminComponent,
    ServicenearSellersDetailsComponent,
    ServicenearSettingsComponent,
    ServicenearSocialProfilesComponent,
    ServicenearMyOtherDevicesComponent,
  ],
  imports: [
    CommonModule,
    ServiceNearRoutingModule,
    ReactiveFormsModule,
    ComponentsModule,
    NgSelectModule,
    FormsModule,
    InfiniteScrollModule,
    NgxPatternLockComponent,
    DragDropModule,
  ],
  exports: [
    ServiceNearToolbarComponent,
    ServiceUniqueIdComponent,
  ]
})
export class ServiceNearModule { }
